import ProductDetail from './scripts';
import './styles/productDetail.scss';
import './styles/productVariant.scss';

export default ProductDetail;
